import React from "react";
import { SearchToolbarContext } from "./SearchToolbar/context";
import { SearchFilterContext } from "./Filter/context";
import { SearchInputFilterContext } from "./SearchInputFilter/context";
import { SearchRefinementContext } from "./SearchRefinementController/context";

/**
 * Wrapper component that provides all search-related contexts
 */
function SearchProviders({
  children,
  toolbarContext,
  filterContext,
  inputFilterContext,
  refinementContext,
}) {
  return (
    <SearchToolbarContext.Provider value={toolbarContext}>
      <SearchFilterContext.Provider value={filterContext}>
        <SearchInputFilterContext.Provider value={inputFilterContext}>
          <SearchRefinementContext.Provider value={refinementContext}>
            {children}
          </SearchRefinementContext.Provider>
        </SearchInputFilterContext.Provider>
      </SearchFilterContext.Provider>
    </SearchToolbarContext.Provider>
  );
}

export default SearchProviders;
